import React, { useMemo, useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import useProgress from '../../hooks/useProgress';
import { EyeIcon } from '@heroicons/react/solid';
import Modal from '../../components/modal';
import CourseUsersTable from './courseUsers';

const CourseOverview = () => {
  const progressQuery = useProgress();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'Course',
        headerName: 'Naam',
        flex: 1,
        valueGetter: (params: any) => {
          return params?.row?.course.title;
        },
        headerClassName: 'bg-gray-100',
      },
      {
        field: 'users',
        headerName: 'Gebruikers',
        headerClassName: 'bg-gray-100',
      },
      {
        field: 'action',
        headerName: '',
        width: 10,
        renderCell: (params) => {
          return (
            <button
              title="Details"
              onClick={() => {
                setSelectedCourse(params?.row?.course?._id);
                setModalOpen(true);
              }}
            >
              <EyeIcon className="w-5 text-gray-500" />
            </button>
          );
        },
        headerClassName: 'bg-gray-100',
      },
    ];
  }, []);

  const data: Array<any> = useMemo(() => {
    try {
      if (!progressQuery.data) {
        return [];
      }

      const res = progressQuery.data.reduce((acc: any, curr: any) => {
        const courseId: string | null = curr?.course?._id;
        if (!courseId) return acc;

        if (!acc[courseId]) {
          acc[courseId] = {
            course: curr.course,
            users: 1,
          };
        } else {
          acc[courseId].users = acc[courseId].users + 1;
        }

        return acc;
      }, {});

      return Object.values(res);
    } catch (error) {
      console.error(error);
      return [];
    }
  }, [progressQuery.data]);

  if (progressQuery.isLoading) return null;
  if (progressQuery.isError) throw progressQuery.error;

  return (
    <>
      <Modal
        isOpen={modalOpen}
        onConfirm={async () => {
          return true;
        }}
        showCancel={false}
        confirmText="Sluiten"
        title="Details"
        setOpen={setModalOpen}
      >
        <CourseUsersTable
          data={progressQuery.data.filter((item: any) => {
            return item?.course?._id === selectedCourse;
          })}
        />
      </Modal>
      <DataGrid
        autoHeight
        rows={data}
        columns={columns}
        getRowId={(row) => row?.course?._id}
        className="bg-white"
      />
    </>
  );
};

export default CourseOverview;
